import { Suspense, useContext, useMemo } from 'react';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';
import { Query } from 'src/modules/common/components/Query/Query.tsx';
import {
    CheckoutPageData,
    CheckoutPageVariables,
    getCheckoutPageConfig,
} from 'src/modules/checkout/CheckoutPageMapping.ts';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from 'src/configContext.ts';
import { useFilterLogic } from 'src/modules/common/hooks/useFilterLogic.ts';
import { useCheckMainFilter } from 'src/modules/common/hooks/useCheckMainFilter.ts';
import { CheckoutPage } from 'src/modules/checkout/CheckoutPage.tsx';
import { buildCheckoutVariables } from 'src/modules/checkout/buildCheckoutVariables.ts';
import { useGetHomeBreadcrumb } from 'src/modules/home/useGetHomeBreadcrumb';
import { useUserInputState } from 'src/modules/user-input/useUserInputState';

export const PrefetchValvesCheckout = () => {
    const { userSettings } = useContext(ConfigContext);
    const pageConfig = useMemo(() => getCheckoutPageConfig(userSettings.currentRegion), [userSettings]);
    if (pageConfig === null) {
        throw new Error('No Page Config!');
    }

    const navigate = useNavigate();

    const { state: userInput, searchParams, locationState } = useUserInputState([]);

    const [
        filter,
    ] = useFilterLogic([
        ...pageConfig.mainFilterConfig,
        ...pageConfig.additionalFilterConfig,
        ...pageConfig.actuatorsFilterConfig,
    ], searchParams);

    useCheckMainFilter({
        filter,
        searchParams,
        navigate,
        filterConfig: [],
    });

    const homePageValue = useGetHomeBreadcrumb({ filter });

    const variables = useMemo(() => buildCheckoutVariables({
        filter,
        userSettings,
        userInput,
        actuatorLabel: locationState.actuatorLabel,
        valveLabel: locationState.valveLabel,
    }), [
        filter,
        locationState,
        userSettings,
        userInput,
    ]);

    return (
        <Suspense fallback={<SkeletonMainLayout/>}>
            <Query<CheckoutPageData, CheckoutPageVariables>
                query={pageConfig.query}
                variables={variables}
            >
                {({ data }) => {
                    if (data === undefined) {
                        return (<SkeletonMainLayout/>);
                    }
                    return (
                        <CheckoutPage
                            navigate={navigate}
                            data={data}
                            homePageValue={homePageValue}
                        />
                    );
                }}
            </Query>
        </Suspense>
    );
};
